module.exports = __webpack_public_path__ + "static/img/bg_card_orders.c5a9d1b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_card_orders.svg
// module id = LuB6
// module chunks = 134